import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';

import './assets/css/bootstrap.min.css';
import './assets/css/icons.css';
import './assets/css/style.css';
import './index.scss';

import { unregister } from './registerServiceWorker';

import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import theme from 'assets/customisedMUI/theme';
import ErrorBoundary from 'components/ErrorBoundary';

//redux
import { Provider } from 'react-redux';

import store from './store/';
import * as Sentry from '@sentry/react';

import { GoogleOAuthProvider } from '@react-oauth/google';
const clientId = '651065819092-t97i9tfuknprp3cl13cg2bgf6c3dapvn.apps.googleusercontent.com';

Sentry.init({
    dsn: 'https://cd140685972e3ad868454df416e45cfb@o4509952834928640.ingest.us.sentry.io/4510264892588032',
    environment: window.location.hostname.includes('lifeskillsgo.com')
        ? window.location.hostname.includes('-staging')
            ? 'staging'
            : 'production'
        : 'development', // sets the environment
    sendDefaultPii: false, //info like user's ip address, user info etc is not sent to sentry
    sampleRate: 0.25, //how much of your app’s request traffic to sample for performance tracing. 0.2 = capture 20% of requests. Sentry randomly picks 1 out of 5 requests to record in detail.
});
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <ErrorBoundary>
                    <GoogleOAuthProvider clientId={clientId}>
                        <App />
                    </GoogleOAuthProvider>
                </ErrorBoundary>
            </ThemeProvider>
        </BrowserRouter>
    </Provider>
);

root.render(app);

unregister();
